import { httpClient } from "../http/httpClient";

export type CreateLinkRequest = {
  name: string;
  tableId: string;
};

export type CreateLinkResponse = {
  _id: string;
  name: string;
  seller: string;
  table: string;
  entry_count: number;
  createdAt: string;
  updatedAt: string;
};

export const createLink = async (params: CreateLinkRequest) => {
  const { data } = await httpClient.post<CreateLinkResponse>('/self-hire', params).catch(
    (error) => {
      throw error?.response?.data || error;
    }
  );
  return data;
};
